@if (isVisible) {
  <div class="bulk-modal-overlay" (click)="close()">
    <div class="bulk-modal" (click)="$event.stopPropagation()">
      <!-- Content -->
      <div class="bulk-modal__content">
        <!-- Icon + Title -->
        <div class="bulk-modal__header">
          <div class="bulk-modal__ai-icon-wrap">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                stroke="#000"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3 class="bulk-modal__title">Generación masiva de autoevaluaciones (IA)</h3>
        </div>

        <!-- Form -->
        <div class="bulk-modal__form">
          <!-- Stats card -->
          <div class="bulk-modal__row">
            <div class="bulk-modal__stats-card">
              @if (isLoadingStats) {
                <div class="bulk-modal__stats-loading">
                  <mat-spinner diameter="18"></mat-spinner>
                </div>
              } @else if (stats) {
                <div class="bulk-modal__stats-body">
                  <div class="bulk-modal__stat-row bulk-modal__stat-row--heading">
                    <span class="bulk-modal__stat-label bulk-modal__stat-label--bold">Total de clases en el curso</span>
                    <span class="bulk-modal__stat-value bulk-modal__stat-value--bold">{{ stats.totalClasses }}</span>
                  </div>
                  <div class="bulk-modal__stat-divider"></div>
                  <div class="bulk-modal__stat-row">
                    <span class="bulk-modal__stat-label">Clases sin autoevaluación (con vídeo y transcripción)</span>
                    <span class="bulk-modal__stat-value bulk-modal__stat-value--green">{{ stats.missingClasses }}</span>
                  </div>
                  <div class="bulk-modal__stat-divider"></div>
                  <div class="bulk-modal__stat-row">
                    <span class="bulk-modal__stat-label">Clases con autoevaluación existente</span>
                    <span class="bulk-modal__stat-value bulk-modal__stat-value--bold">{{ stats.existingClasses }}</span>
                  </div>
                </div>
              }
            </div>

            <!-- Mode options -->
            <div class="bulk-modal__options">
              <!-- Option: missing only (default) -->
              <button
                type="button"
                class="bulk-modal__option"
                [class.bulk-modal__option--selected]="selectedMode === 'missing'"
                (click)="selectedMode = 'missing'"
              >
                <div class="bulk-modal__checkbox" [class.bulk-modal__checkbox--checked]="selectedMode === 'missing'">
                  <svg viewBox="0 0 10 8" width="10" height="8" [style.visibility]="selectedMode === 'missing' ? 'visible' : 'hidden'">
                    <path d="M1 4l3 3 5-6" stroke="#f8f9fa" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="bulk-modal__option-text">
                  <span class="bulk-modal__option-title">Generar autoevaluaciones solo para las clases vacías</span>
                  <span class="bulk-modal__option-desc">Recomendado — Protege las autoevaluaciones existentes</span>
                </div>
              </button>

              <!-- Option: all (overwrite) -->
              <button
                type="button"
                class="bulk-modal__option"
                [class.bulk-modal__option--selected]="selectedMode === 'all'"
                (click)="selectedMode = 'all'"
              >
                <div class="bulk-modal__checkbox" [class.bulk-modal__checkbox--checked]="selectedMode === 'all'">
                  <svg viewBox="0 0 10 8" width="10" height="8" [style.visibility]="selectedMode === 'all' ? 'visible' : 'hidden'">
                    <path d="M1 4l3 3 5-6" stroke="#f8f9fa" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div class="bulk-modal__option-text">
                  <span class="bulk-modal__option-title">Sobrescribir las autoevaluaciones existentes</span>
                  <span class="bulk-modal__option-desc bulk-modal__option-desc--danger">Perderás las ediciones manuales realizadas</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="bulk-modal__footer">
        <button class="bulk-modal__btn-cancel" (click)="close()">Cancelar</button>
        <button class="bulk-modal__btn-confirm" [disabled]="isStarting || isLoadingStats || classCountForMode === 0" (click)="startGeneration()">
          @if (isStarting) {
            <mat-spinner diameter="16"></mat-spinner>
          }
          @if (!stats || isLoadingStats) {
            Generar autoevaluaciones
          } @else {
            Generar {{ classCountForMode }} autoevaluaci{{ classCountForMode === 1 ? 'ón' : 'ones' }}
          }
        </button>
      </div>
    </div>
  </div>
}
